import React from "react";
import { useTranslation } from "react-i18next";
import { getLatestSurvey } from "../../utils/multiTeamReport";
import styles from "../../styles/database.module.css";

function sortSurveysByDate(encuestas) {
    return [...(encuestas || [])]
        .filter(Boolean)
        .sort((a, b) => {
            const finA = new Date(a.fecha_fin || 0).getTime();
            const finB = new Date(b.fecha_fin || 0).getTime();
            if (finB !== finA) return finB - finA;
            const iniA = new Date(a.fecha_inicio || 0).getTime();
            const iniB = new Date(b.fecha_inicio || 0).getTime();
            return iniB - iniA;
        });
}

function TeamSurveySelector({
    teamIds,
    findTeamById,
    selectedSurveys,
    getCompanyColor,
    formatDate,
    onSelectSurvey,
}) {
    const { t } = useTranslation();

    return (
        <div className={styles.teamSurveyList}>
            {teamIds.map((teamId) => {
                const team = findTeamById(teamId);
                if (!team) return null;

                const latest = getLatestSurvey(team.encuestas);
                const surveys = sortSurveysByDate(team.encuestas);
                const selectedId =
                    surveys.find((s) => selectedSurveys.includes(s.id_encuesta))?.id_encuesta ??
                    latest?.id_encuesta;

                return (
                    <div
                        key={teamId}
                        className={styles.teamSurveyCard}
                        style={{ "--team-accent": getCompanyColor?.(teamId) || "#ddd" }}
                    >
                        <div className={styles.teamSurveyCardHeader}>{team.nombre}</div>

                        {surveys.length === 0 ? (
                            <p className={styles.teamSurveyEmpty}>
                                {t("multiTeamsReport.noSurveyForTeam")}
                            </p>
                        ) : surveys.length === 1 ? (
                            <div className={styles.teamSurveySingle}>
                                <span className={styles.teamSurveyDates}>
                                    {formatDate(surveys[0].fecha_inicio)} – {formatDate(surveys[0].fecha_fin)}
                                </span>
                                {surveys[0].estado === "activa" && (
                                    <span className={styles.activeBadge}>{t("activa")}</span>
                                )}
                            </div>
                        ) : (
                            <div className={styles.teamSurveyOptions} role="radiogroup" aria-label={team.nombre}>
                                {surveys.map((survey) => (
                                    <label
                                        key={survey.id_encuesta}
                                        className={`${styles.surveyRadioOption} ${
                                            selectedId === survey.id_encuesta ? styles.surveyRadioOptionSelected : ""
                                        }`}
                                    >
                                        <input
                                            type="radio"
                                            name={`team-survey-${teamId}`}
                                            checked={selectedId === survey.id_encuesta}
                                            onChange={() => onSelectSurvey(survey.id_encuesta, teamId)}
                                        />
                                        <span className={styles.surveyRadioContent}>
                                            <span className={styles.teamSurveyDates}>
                                                {formatDate(survey.fecha_inicio)} – {formatDate(survey.fecha_fin)}
                                            </span>
                                            <span className={styles.surveyRadioBadges}>
                                                {latest?.id_encuesta === survey.id_encuesta && (
                                                    <span className={styles.latestBadge}>
                                                        {t("multiTeamsReport.latestBadge")}
                                                    </span>
                                                )}
                                                {survey.estado === "activa" && (
                                                    <span className={styles.activeBadge}>{t("activa")}</span>
                                                )}
                                            </span>
                                        </span>
                                    </label>
                                ))}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
}

export default TeamSurveySelector;
